module.exports = __webpack_public_path__ + "static/cloud-952c0a306acdfc25949e49ee18197bd3.png";